/* TSOColorPreview — standalone colored-product compositor.
 *
 * Extracted from the builder's accessory canvas renderer
 * (custom-build-product-script-new.js renderAccessoryCanvases/drawAll) so
 * surfaces OUTSIDE the builder (upsell cards) can show a product rendered in
 * the buyer's picked powder colors. Same layer contract as the builder:
 *   base (main_image) -> truck -> tip (tinted primary | polished image)
 *   -> overlay (tinted secondary | polished image) -> screw
 * Layers with no URL are skipped. Images load with crossOrigin=anonymous so
 * the canvas stays untainted for toBlob (preview upload).
 *
 * API:
 *   TSOColorPreview.render(canvas, layers, colors) -> Promise<void>
 *     layers: { base, truck, tip, tipPolished, overlay, overlayPolished, screw } (urls)
 *     colors: { primaryHex, primaryPolished, secondaryHex, secondaryPolished }
 *
 * NOTE: the builder still carries its own copy of this logic — migrating it
 * here requires a verify-builder-frame pass and is deliberately deferred.
 */
(function () {
  'use strict';
  if (window.TSOColorPreview) return;

  function loadImage(url) {
    return new Promise(function (resolve) {
      if (!url) return resolve(null);
      var img = new window.Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = function () { resolve(null); };
      img.src = url;
    });
  }

  function setupHiDPI(canvas, ctx) {
    var dpr = window.devicePixelRatio || 1;
    var parent = canvas.parentElement;
    var cssW = (parent && parent.offsetWidth) || canvas.offsetWidth || 300;
    var cssH = (parent && parent.offsetHeight) || canvas.offsetHeight || cssW;
    canvas.width = Math.round(cssW * dpr);
    canvas.height = Math.round(cssH * dpr);
    canvas.style.width = cssW + 'px';
    canvas.style.height = cssH + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    return { w: cssW, h: cssH };
  }

  function drawCover(ctx, img, dstW, dstH) {
    if (!img) return;
    var sw = img.naturalWidth || img.width;
    var sh = img.naturalHeight || img.height;
    var scale = Math.max(dstW / sw, dstH / sh);
    var sW = dstW / scale;
    var sH = dstH / scale;
    var sx = (sw - sW) / 2;
    var sy = (sh - sH) / 2;
    ctx.drawImage(img, sx, sy, sW, sH, 0, 0, dstW, dstH);
  }

  function tintAndDraw(ctx, img, colorHex, dstW, dstH) {
    if (!img || !colorHex) return;
    var sw = img.naturalWidth || img.width;
    var sh = img.naturalHeight || img.height;
    var off = document.createElement('canvas');
    off.width = sw;
    off.height = sh;
    var octx = off.getContext('2d');
    octx.drawImage(img, 0, 0, sw, sh);
    octx.globalCompositeOperation = 'multiply';
    octx.fillStyle = colorHex;
    octx.fillRect(0, 0, sw, sh);
    octx.globalCompositeOperation = 'destination-in';
    octx.drawImage(img, 0, 0, sw, sh);
    // draw the tinted offscreen with the same cover math as plain layers
    drawCover(ctx, off, dstW, dstH);
  }

  window.TSOColorPreview = {
    render: function (canvas, layers, colors) {
      var ctx = canvas.getContext('2d');
      return Promise.all([
        loadImage(layers.base),
        loadImage(layers.truck),
        loadImage(layers.tip),
        loadImage(layers.tipPolished),
        loadImage(layers.overlay),
        loadImage(layers.overlayPolished),
        loadImage(layers.screw)
      ]).then(function (imgs) {
        var size = setupHiDPI(canvas, ctx);
        ctx.clearRect(0, 0, size.w, size.h);
        drawCover(ctx, imgs[0], size.w, size.h);
        drawCover(ctx, imgs[1], size.w, size.h);
        if (colors.primaryPolished) drawCover(ctx, imgs[3], size.w, size.h);
        else tintAndDraw(ctx, imgs[2], colors.primaryHex, size.w, size.h);
        if (colors.secondaryPolished) drawCover(ctx, imgs[5], size.w, size.h);
        else tintAndDraw(ctx, imgs[4], colors.secondaryHex, size.w, size.h);
        drawCover(ctx, imgs[6], size.w, size.h);
      });
    }
  };
})();
